<template>
  <div class="autocomplete" v-click-outside="disable">
    <input type="text" v-on:click="enable" v-model="initialText" class="form-control secondary" v-bind:placeholder="placeholder">
    <div v-if="optionValues.length > 0 && enabled" class="list-container">
      <ul>
        <li v-for="value in optionValues" v-on:click="setValue(value)">{{value.text}}</li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Autocompletesimple',
  props: ['valuekey', 'text', 'placeholder', 'data', 'value'],
  data: function()
  {
    return {optionValues: [], initialText: '', nochange: false, enabled: false};
  },
  created: function()
  {
    var me = this;
    me.$emit('query', {query: '', initialId: me.value, start: 0, limit: 20});
  },
  watch:
  {
    initialText(val)
    {
      var me = this;
      if(!me.nochange) me.$emit('query', {query: val, start: 0, limit: 20});
      me.nochange = false;
    },
    data()
    {
      var me = this;
      me.optionValues = [];
      for(var val of me.data)
      {
        var text = '';
        if(typeof me.text != 'string')
        {
          var tmp = [];
          for(var key of me.text)
          {
            tmp.push(val[key]);
          }
          text = tmp.join(' ', tmp);
        }
        else
        {
          text = val[me.text];
        }

        if(me.value == val[me.valuekey])
        {
          me.nochange = true;
          me.initialText = text;
        }

        me.optionValues.push({value: val[me.valuekey], text: text})
      }
    }
  },
  methods:
  {
    setValue(val)
    {
      var me = this;
      me.$emit('input', val.value)
      me.nochange = true;
      me.initialText = val.text;
      me.optionValues = [];
    },
    hideSelector()
    {
      var me = this;
      me.optionValues = [];
    },
    enable()
    {
      this.enabled = true;
    },
    disable()
    {
      this.enabled = false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lib/Autocompletesimple.vue